import React from 'react'
import Button from '../elements/Button'
import globals from '../globals'
import NoticesHOC from '../modules/NoticesHOC'
import { withRouter } from 'react-router-dom'

const NoticeSubscribeHomeSecureWithTrial = (props) => {
    const handleClick = event => {
        event.preventDefault()
        props.hideNotice()
        props.history.push('/subscribe-home-secure')
    }

    return (
        <div className='row text-center'>
            <div className='col-12 col-lg-10 offset-lg-1'>
                <h2>Subscribe to Home Secure - get first 3 months FREE <br className='d-none d-lg-inline' />Network level protection for just $6/mth</h2>
                <p className='lh'>Because <span className='bold'>Home Secure</span> works at the level of your internet connection, it helps protect every device connected to your Exetel home internet or WiFi. You can quickly and easily set or adjust your content and security settings to help block inappropriate content and malicious sites that seek to mess with your world.</p>
                <p className='lh mb-0' dangerouslySetInnerHTML={{ __html: globals.noWidows('Take control of your home internet security and content settings. No lock-in.') }} />
                <p className='lh mt-0'><a href='https://www.exetel.com.au/broadband/nbn/home-secure' target='_blank'>Learn more</a></p>
                <Button title='Subscribe now' action={handleClick} />
            </div>
        </div>
    )
}

export default withRouter(NoticesHOC(NoticeSubscribeHomeSecureWithTrial))



// WEBPACK FOOTER //
// ./resources/js/components/NoticeSubscribeHomeSecureWithTrial.js